import DpsProductGroupHeader from './DpsProductGroupHeader';

export default DpsProductGroupHeader;
